import * as React from "react";
// UI Frameworks
import { Form, Button as AntButton } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Button from "components/Button";
import Input from "components/Input";
//utilities and hooks
import useUser from "hooks/useUser";
import showNotify from "helpers/notify";
import { normalizeNumbers } from "helpers/persian";
//styles
import styles from "./index.module.scss";

interface IProps extends FormComponentProps {
	store: any;
	onChangeMobile: () => void;
}

const CodeValidation: React.FC<IProps> = props => {
	const { getFieldDecorator } = props.form;
	const [loading, setLoading] = React.useState(false);
	const { loginConfirm } = useUser();

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		props.form.validateFields(async (err, values) => {
			if (!err) {
				try {
					setLoading(true);
					await loginConfirm({
						mobile: props.store.username,
						rememberMe: props.store.rememberMe,
						code: values.code,
					});
					setLoading(false);
				} catch (error) {
					setLoading(false);
					showNotify({
						text: "کد تایید نامعتبر است.",
						duration: 3000,
					});
				}
			}
		});
	}

	// async function onCounterResend() {
	// 	setIsTimerComplete(false);

	// 	await AuthService.sendActivationCode(props.mobile);
	// }

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit} className={styles["code-validation"]}>
				<Form.Item>
					{getFieldDecorator("code", {
						normalize: normalizeNumbers,
						rules: [
							{
								required: true,
								transform: value => (value ? value.trim() : value),
								message: "لطفا کد تایید را وارد نمایید!",
							},
						],
					})(<Input placeholder="کد تایید" maxLength={5} type="tel" />)}
				</Form.Item>
				{/*<div style={{ height: 50 }}>
					{isTimerComplete ? (
						<Button
							primary
							ghost
							onClick={async () => {
								await onCounterResend();
							}}
						>
							ارسال مجدد کد پیامکی
						</Button>
					) : (
						<Counter counter={120} onFinished={() => setIsTimerComplete(true)} />
					)}
					</div>*/}
				<AntButton type="link" style={{ padding: 0 }} onClick={props.onChangeMobile}>
					تغییر شماره موبایل
				</AntButton>
				<Form.Item className="button-center">
					<Button htmlType="submit" primary loading={loading}>
						تایید
					</Button>
				</Form.Item>
			</Form>
		</React.Fragment>
	);
};

export default Form.create<IProps>({ name: "CodeValidation" })(React.memo(CodeValidation));
